var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30.199,
    viewBox: "0 0 30 30.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_Titolo_Utenti",
    "data-name": "icona Titolo Utenti",
    transform: "translate(-1268 -718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_916",
    "data-name": "Tracciato 916",
    d: "M83.26,201.134a6.361,6.361,0,0,1,5.094,6.2v4.616H72.63v-4.616a6.361,6.361,0,0,1,5.094-6.2,6.666,6.666,0,0,0,5.536,0m-.147-1.04a5.668,5.668,0,0,1-5.242,0,7.345,7.345,0,0,0-6.241,7.238v4.815a.8.8,0,0,0,.8.8H88.553a.8.8,0,0,0,.8-.8v-4.815a7.344,7.344,0,0,0-6.24-7.238Z",
    transform: "translate(1202.507 535.052)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_917",
    "data-name": "Tracciato 917",
    d: "M231.5,135.582a5.684,5.684,0,0,1-2.621.642h0a6.13,6.13,0,0,1-1.665,3.81,8.884,8.884,0,0,1,5.893,8.314v.088h3.837a.8.8,0,0,0,.8-.8V142.82A7.345,7.345,0,0,0,231.5,135.582Z",
    transform: "translate(1060.262 594.036)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_918",
    "data-name": "Tracciato 918",
    d: "M231.644,136.622a6.361,6.361,0,0,1,5.094,6.2v4.616h-2.681a9.861,9.861,0,0,0-5.277-7.806,7.171,7.171,0,0,0,.976-2.464,6.628,6.628,0,0,0,1.887-.544m-.147-1.04a5.684,5.684,0,0,1-2.621.642h0a6.13,6.13,0,0,1-1.665,3.81,8.884,8.884,0,0,1,5.893,8.314v.088h3.837a.8.8,0,0,0,.8-.8V142.82a7.345,7.345,0,0,0-6.241-7.238Z",
    transform: "translate(1060.262 594.036)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_921",
    "data-name": "Tracciato 921",
    d: "M4.638,148.348a8.884,8.884,0,0,1,5.892-8.314,6.129,6.129,0,0,1-1.665-3.81h0a5.685,5.685,0,0,1-2.621-.642A7.345,7.345,0,0,0,0,142.82v4.815a.8.8,0,0,0,.8.8H4.638Z",
    transform: "translate(1268 594.036)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_922",
    "data-name": "Tracciato 922",
    d: "M6.094,136.622a6.63,6.63,0,0,0,1.887.544,7.175,7.175,0,0,0,.976,2.464,9.862,9.862,0,0,0-5.276,7.806H1V142.82a6.361,6.361,0,0,1,5.094-6.2m.147-1.04A7.345,7.345,0,0,0,0,142.82v4.815a.8.8,0,0,0,.8.8H4.638v-.088a8.884,8.884,0,0,1,5.892-8.314,6.129,6.129,0,0,1-1.665-3.81h0a5.683,5.683,0,0,1-2.621-.642Z",
    transform: "translate(1268 594.036)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellisse_63",
    "data-name": "Ellisse 63",
    transform: "translate(1277.375 723.625)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.625,
    cy: 5.625,
    r: 5.625,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.625,
    cy: 5.625,
    r: 5.125,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sottrazione_3",
    "data-name": "Sottrazione 3",
    transform: "translate(1283.077 718)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.826271057128906 10.69370365142822 C 6.560816287994385 7.284010410308838 3.893410205841064 4.600025653839111 0.4879012703895569 4.313329219818115 C 1.07574737071991 2.020549774169922 3.136840581893921 0.3999980092048645 5.548615455627441 0.3999980092048645 C 8.429385185241699 0.3999980092048645 10.77305507659912 2.743668079376221 10.77305507659912 5.624437808990479 C 10.77305507659912 8.053016662597656 9.138199806213379 10.11812019348145 6.826271057128906 10.69370365142822 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.171134948730469 10.1730260848999 C 9.069083213806152 9.503464698791504 10.37305545806885 7.708948612213135 10.37305545806885 5.624437808990479 C 10.37305545806885 2.964227914810181 8.20882511138916 0.7999980449676514 5.548615455627441 0.7999980449676514 C 3.479632377624512 0.7999980449676514 1.690055251121521 2.091516494750977 1.011077761650085 3.972060203552246 C 4.215639591217041 4.454826831817627 6.709285259246826 6.964938640594482 7.171134948730469 10.1730260848999 M 6.447595596313477 11.17895793914795 L 6.447585582733154 11.17677783966064 C 6.408335208892822 7.599977970123291 3.576225519180298 4.750197887420654 -4.559783974400489e-06 4.68897819519043 C 0.4551754295825958 1.971078038215637 2.789455413818359 -1.984100435947767e-06 5.548615455627441 -1.984100435947767e-06 C 8.649935722351074 -1.984100435947767e-06 11.17305564880371 2.523108005523682 11.17305564880371 5.624437808990479 C 11.17305564880371 8.401927947998047 9.186614990234375 10.73780822753906 6.449755668640137 11.17861843109131 L 6.447595596313477 11.17895793914795 Z",
    stroke: "none",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sottrazione_4",
    "data-name": "Sottrazione 4",
    transform: "translate(1283.164 729.173) rotate(180)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.548479080200195 10.77293872833252 C 3.137584209442139 10.77293872833252 1.077001214027405 9.153459548950195 0.4883913397789001 6.861922740936279 C 3.856895685195923 6.585484981536865 6.585465908050537 3.856914043426514 6.861920356750488 0.4883930087089539 C 9.153448104858398 1.077012181282043 10.77291870117188 3.137604236602783 10.77291870117188 5.54849910736084 C 10.77291870117188 8.429268836975098 8.429248809814453 10.77293872833252 5.548479080200195 10.77293872833252 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.548479080200195 10.37293910980225 C 8.208688735961914 10.37293910980225 10.3729190826416 8.208708763122559 10.3729190826416 5.54849910736084 C 10.3729190826416 3.480457067489624 9.082595825195313 1.691508531570435 7.203371524810791 1.011884093284607 C 6.723659038543701 4.182888507843018 4.182868957519531 6.723678112030029 1.011876821517944 7.203375339508057 C 1.691492676734924 9.082606315612793 3.480437040328979 10.37293910980225 5.548479080200195 10.37293910980225 M 5.548479080200195 11.17293930053711 C 2.788709163665771 11.17293930053711 0.4552291631698608 9.201189041137695 -8.401489139941987e-07 6.484559059143066 C 3.535459041595459 6.443629264831543 6.443609237670898 3.535649061203003 6.484559059143066 -8.265686233244196e-07 C 9.202109336853027 0.4553991854190826 11.17291927337646 2.789639234542847 11.17291927337646 5.54849910736084 C 11.17291927337646 8.649828910827637 8.649808883666992 11.17293930053711 5.548479080200195 11.17293930053711 Z",
    stroke: "none",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTitle);
export default __webpack_public_path__ + "static/media/user_title.c44a0fbe46be0cd44f90725d284ff854.svg";
export { ForwardRef as ReactComponent };